import { RETURN_APPROVAL_MESSAGES } from 'src/app/constants/returns.constants';
import { PermissionContext, PermissionType } from 'src/app/model';

export const approvalSequence: PermissionType[] = [
  PermissionType.ApprovePreparation,
  PermissionType.ApproveReview,
  PermissionType.ApproveSignerReview,
  PermissionType.ApproveClientApproval,
  PermissionType.ApproveEFiling,
  PermissionType.ApproveConfirmationReview,
];

export const columnMap: Record<PermissionType, { userCol: string; dateCol: string, userColName: string; dateColName: string }> = {
  [PermissionType.ApprovePreparation]: { userCol: 'BT', dateCol: 'BU', userColName: 'Preparation Complete', dateColName: 'Preparation Complete (Date and Time)' },
  [PermissionType.ApproveReview]: { userCol: 'BV', dateCol: 'BW', userColName: 'Review Complete', dateColName: 'Review Complete  (Date and Time)' },
  [PermissionType.ApproveSignerReview]: { userCol: 'BX', dateCol: 'BY', userColName: 'Signer Review Complete', dateColName: 'Signer Review Complete (Date and Time)' },
  [PermissionType.ApproveClientApproval]: { userCol: 'CN', dateCol: 'CO', userColName: 'Client Approval', dateColName: 'Client Approval (Date and Time)' },
  [PermissionType.ApproveEFiling]: { userCol: 'CG', dateCol: 'CH', userColName: 'E-Filing Submitted', dateColName: 'E-Filing Submitted (Date and Time)' },
  [PermissionType.ApproveConfirmationReview]: { userCol: 'CI', dateCol: 'CJ', userColName: 'Final Confirmation Complete', dateColName: 'Final Confirmation Complete (Date and Time)' },
};

export const requiredCellChecks: Partial<Record<PermissionType, { colName: string; errorMessage: string }[]>> = {
  [PermissionType.ApproveEFiling]: [{ 
    colName: 'E-File Confirmation Number', 
    errorMessage: RETURN_APPROVAL_MESSAGES.EFileConfirmationRequired
  }],
};

export const buttonConfigs = [
  {
    permission: PermissionType.ApprovePreparation,
    icon: 'ph-check-circle',
    label: 'Preparation Complete',
    canShow: (permissions: PermissionContext) => permissions.canApprovePreparation,
  },
  {
    permission: PermissionType.ApproveReview,
    icon: 'ph-clipboard',
    label: 'Review Complete',
    canShow: (permissions: PermissionContext) => permissions.canApproveReview,
  },
  {
    permission: PermissionType.ApproveSignerReview,
    icon: 'ph-check-square',
    label: 'Signer Review Complete',
    canShow: (permissions: PermissionContext) => permissions.canApproveSignerReview,
  },
  {
    permission: PermissionType.ApproveClientApproval,
    icon: 'ph-user-check',
    label: 'Client Approval',
    canShow: (permissions: PermissionContext) => permissions.canApproveClientApproval,
  },
  {
    permission: PermissionType.ApproveEFiling,
    icon: 'ph-file-arrow-up',
    label: 'E-Filing Submitted',
    canShow: (permissions: PermissionContext) => permissions.canApproveEFiling,
  },
  {
    permission: PermissionType.ApproveConfirmationReview,
    icon: 'ph-credit-card',
    label: 'Final Confirmation Complete',
    canShow: (permissions: PermissionContext) => permissions.canApproveConfirmationReview,
  },
];
